import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';

class UserSuspendedTask extends AbstractRequestTask {
    constructor(params, version = 'v1') {
        super();
        this.params = params;
        this.version = version;
    }

    getMethod() {
        return 'GET';
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.user_token
        };
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.user_token;
        return {
            ...params
        };    
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        return `${http}${url}/services/payway/paymentservice/${this.version}/usersuspended`;
    }

    isValid(data) {
        if (data.errors || !data.response || data.response === 'error') {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default UserSuspendedTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/payway/UserSuspendedTask.js